
import '../../../styles/style.css';
import React, { useState,useEffect } from 'react';
import useFetch from '../../api/useFetch';
//import { ColumnMenu, PersonCell } from './custom-cells';
import { ScrollView } from '@progress/kendo-react-scrollview';

const CumpleanerosCards = () => {
  const { data: empleados } = useFetch("api/Empleados/Empleados");
  const [query, setQuery] = useState("");

  const empleadosData = empleados || [];
  const mesActual = new Date().getMonth() + 1;

  const filteredData = empleadosData
    .filter(emp => JSON.stringify(emp).toLowerCase().includes(query.toLowerCase()))
    .filter(emp => {
      if (!emp.fh_Nacimiento) return false;
      const mesNacimiento = parseInt(emp.fh_Nacimiento.split("-")[1]);
      return mesNacimiento === mesActual;
    })
    .sort((a, b) => new Date(a.fh_Nacimiento) - new Date(b.fh_Nacimiento));

  return (
    <div className="cards-container">
     <ScrollView
    style={{ height: 320 }} 
    speed={3000} 
    loop={true}             
    pageable={false}             // ✅ sin puntos
    navigators={false}           // ✅ sin flechas
    automaticViewChange={true}
    endless={true}
    arrows={false}
>
  {filteredData.map((emp) => {

    const [year, month, day] = emp.fh_Nacimiento.split("T")[0].split("-");
    const fecha = `${day}/${month}`;

    const imageSrc = emp.img_Empleado
      ? emp.img_Empleado.startsWith("data:image")
        ? emp.img_Empleado
        : `data:image/jpeg;base64,${emp.img_Empleado}`
      : "/avatar-default.png";
    
    return (
       
      <div key={emp.id_Empleado} className="card">
        <div className="card-image">
          <img src={imageSrc} />
        </div>
        <div className="card-content">
          <h3>{emp.nombreCompleto}</h3>
          <span className="birthday-badge">{fecha}</span>
          <p className="puesto">{emp.nb_Puesto}</p>
        </div>
      </div>
    );
  })}
</ScrollView>
    </div>
  );
};

export default CumpleanerosCards;

